import {css, keyframes, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {borderRadius, calculateRemSize, color, fadeInAnimation, flexAlignCenter, flexDirection, mb, pointer} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {priceFormat} from "@pg-mono/string-utils";

export interface IBarProps {
    name: string;
    citySlug: string;
    hsl: [number, number, number];
    value: number;
    total: number;
    animationDelay: number;
}
export const calculateBarHeight = (partialValue: number, totalValue: number): number => Math.round((100 * partialValue) / totalValue);

export const SingleBar = (props: IBarProps) => {
    const {name, citySlug, hsl, value, total, animationDelay} = props;
    const href = rpAppLink.prices.flats.city({regionSlug: citySlug});

    const theme = useTheme();

    const height = value > 0 && total > 0 ? calculateBarHeight(value, total) : 12;

    return (
        <div css={barWrapper}>
            <StyledBarValue color={theme.colors.gray[800]} animationDelay={animationDelay}>
                <Text as="span" variant="body_copy_2" strong>
                    {priceFormat(Math.round(value))}
                </Text>
                <Text as="span" variant="info_txt_2">{`/m${String.fromCharCode(178)}`}</Text>
            </StyledBarValue>

            <StyledBar hsl={hsl} barHeight={height} animationDelay={animationDelay} />

            <Link css={barTitle} href={href} target="_blank">
                <Text as="span" variant="body_copy_2">
                    {name}
                </Text>
            </Link>
        </div>
    );
};

const barWrapper = css`
    ${flexAlignCenter};
    ${flexDirection("column")};
`;

const growBar = (targetHeight: number) => keyframes`
    from {
        height: ${calculateRemSize(5)};
    }
    to {
        height: ${targetHeight}px;
    }
`;

interface IStyledBarProps {
    hsl: IBarProps["hsl"];
    barHeight: number;
    animationDelay: number;
}

const StyledBar = styled.div<IStyledBarProps>`
    background-color: hsl(${({hsl}) => hsl[0]}, ${({hsl}) => hsl[1]}%, ${({hsl}) => hsl[2]}%);
    width: ${calculateRemSize(6)};
    ${borderRadius(2)};
    ${mb(2.5)};
    animation: ${(props) => growBar(props.barHeight * 3.5)} 1s ease;
    animation-delay: ${({animationDelay}) => animationDelay}s;
    animation-fill-mode: forwards;
    height: ${calculateRemSize(5)};
`;

const StyledBarValue = styled.span<{animationDelay: number}>`
    ${mb(1)};
    opacity: 0;
    ${fadeInAnimation("0.6s")};
    animation-delay: ${({animationDelay}) => animationDelay + 1}s;
    animation-fill-mode: forwards;
`;

const barTitle = (theme: Theme) => css`
    text-transform: uppercase;
    ${color(theme.colors.gray[700])};
    ${pointer};
    text-decoration: none !important;
`;
import {css, keyframes, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {borderRadius, calculateRemSize, color, fadeInAnimation, flexAlignCenter, flexDirection, mb, pointer} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {priceFormat} from "@pg-mono/string-utils";

export interface IBarProps {
    name: string;
    citySlug: string;
    hsl: [number, number, number];
    value: number;
    total: number;
    animationDelay: number;
}
export const calculateBarHeight = (partialValue: number, totalValue: number): number => Math.round((100 * partialValue) / totalValue);

export const SingleBar = (props: IBarProps) => {
    const {name, citySlug, hsl, value, total, animationDelay} = props;
    const href = rpAppLink.prices.flats.city({regionSlug: citySlug});

    const theme = useTheme();

    const height = value > 0 && total > 0 ? calculateBarHeight(value, total) : 12;

    return (
        <div css={barWrapper}>
            <StyledBarValue color={theme.colors.gray[800]} animationDelay={animationDelay}>
                <Text as="span" variant="body_copy_2" strong>
                    {priceFormat(Math.round(value))}
                </Text>
                <Text as="span" variant="info_txt_2">{`/m${String.fromCharCode(178)}`}</Text>
            </StyledBarValue>

            <StyledBar hsl={hsl} barHeight={height} animationDelay={animationDelay} />

            <Link css={barTitle} href={href} target="_blank">
                <Text as="span" variant="body_copy_2">
                    {name}
                </Text>
            </Link>
        </div>
    );
};

const barWrapper = css`
    ${flexAlignCenter};
    ${flexDirection("column")};
`;

const growBar = (targetHeight: number) => keyframes`
    from {
        height: ${calculateRemSize(5)};
    }
    to {
        height: ${targetHeight}px;
    }
`;

interface IStyledBarProps {
    hsl: IBarProps["hsl"];
    barHeight: number;
    animationDelay: number;
}

const StyledBar = styled.div<IStyledBarProps>`
    background-color: hsl(${({hsl}) => hsl[0]}, ${({hsl}) => hsl[1]}%, ${({hsl}) => hsl[2]}%);
    width: ${calculateRemSize(6)};
    ${borderRadius(2)};
    ${mb(2.5)};
    animation: ${(props) => growBar(props.barHeight * 3.5)} 1s ease;
    animation-delay: ${({animationDelay}) => animationDelay}s;
    animation-fill-mode: forwards;
    height: ${calculateRemSize(5)};
`;

const StyledBarValue = styled.span<{animationDelay: number}>`
    ${mb(1)};
    opacity: 0;
    ${fadeInAnimation("0.6s")};
    animation-delay: ${({animationDelay}) => animationDelay + 1}s;
    animation-fill-mode: forwards;
`;

const barTitle = (theme: Theme) => css`
    text-transform: uppercase;
    ${color(theme.colors.gray[700])};
    ${pointer};
    text-decoration: none !important;
`;
